
import { defineComponent, reactive, toRefs } from 'vue'

interface State {
  copied: boolean;
}

export default defineComponent({
  name: 'Code',
  props: {
    code: {
      type: String,
      required: true
    },
  },
  computed: {
    showCopyButton() {
      return navigator?.clipboard
    }
  },
  setup(props) {
    const state = reactive<State>({
      copied: false,
    })
    const copyTo = () => {
      navigator.clipboard.writeText(props.code)
      state.copied = true
      setTimeout(() => state.copied = false, 1000)
    }
    return {
      ...toRefs(state),
      copyTo,
    }
  },
})

